export default [
  ['cancel', 'Cancellation'],
  ['port_out', 'Port out'],
  ['mdn_change', 'MDN change'],
  ['nonpayment', 'Non-payment'],
  ['internal_movement', 'Internal Movement'],
];
